export default __webpack_public_path__ + "static/media/cfdWorkIcon1.9eb9c50e.webp";